<template>
  <div style="display: inline-block; width: 100%;">
    <div style="display: inline-block; float: left;">
      {{ displayValue }}
    </div>
    <button
      v-if="showBtn"
      style="display: inline-block; float: right;"
      @click="handleBtnClick">
      {{ btnLabel }}
    </button>
  </div>
</template>

<script>
  export default {
    name: 'SpecialCell',
    props: [
      'displayValue',
      'btnLabel',
      'showBtn'
    ],
    methods: {
      handleBtnClick (e) {
        e.preventDefault()
        this.$emit('specialCellBtnClick')
      }
    }
  }
</script>
